import { CategoryTypes } from "../../../../interfaces/enums";
import { CategoryWithId } from "../../../../interfaces/ICategories";
import { DisplayData } from "./presentationDisplayUtils";
import { Typography } from "@mui/material";

interface PresentationNameProps {
  presentation: any;
  category: CategoryWithId;
  displayData: DisplayData;
}

export default function PresentationName({
  presentation,
  category,
  displayData,
}: PresentationNameProps) {
  return (
    <Typography variant="h6" sx={{ fontWeight: 600, color: "#2f2f2f" }}>
      {/* Wyświetlanie dla kategorii Solo */}
      {category.type === CategoryTypes.SOLO && displayData.hasStyledYears && (
        <>
          {displayData.text}
          {displayData.years && (
            <span style={{ color: "#6c6c6c", fontWeight: 400, fontSize: "0.9em" }}>
              {" "}
              ({displayData.years})
            </span>
          )}
        </>
      )}

      {/* Wyświetlanie dla kategorii Duet i Trio */}
      {(category.type === CategoryTypes.DUO || category.type === CategoryTypes.TRIO) &&
        displayData.hasStyledYears &&
        displayData.participantsData && (
          <>
            {displayData.participantsData.map((participant: any, index: number) => (
              <span key={index}>
                {index > 0 && ", "}
                {participant.name}
                {participant.year && (
                  <span style={{ color: "#6c6c6c", fontWeight: 400, fontSize: "0.9em" }}>
                    {" "}
                    ({participant.year})
                  </span>
                )}
              </span>
            ))}
          </>
        )}

      {/* Wyświetlanie dla kategorii Inne */}
      {category.type === CategoryTypes.OTHER && displayData.text}

      {/* Tytuł prezentacji */}
      {presentation.title && (
        <span style={{ color: "#6c6c6c", fontWeight: 400 }}>
          {" - "}
          {presentation.title}
        </span>
      )}
    </Typography>
  );
}
